import React, { Fragment } from 'react'
import { Card, CardContent } from '@material-ui/core'

import Chart from './Chart'

const Charts = ({ classes, country, channels }) => {
  return (
    <Fragment>
      <Card className={classes.spacing}>
        <CardContent>
          <h3 className={classes.h3}>Referral dynamics</h3>
          <Chart country={country} classes={classes} channels={channels} />
        </CardContent>
      </Card>
      <Card className={classes.spacing}>
        <CardContent>
          <h3 className={classes.h3}>Referral dynamics</h3>
          <Chart
            country={country}
            classes={classes}
            channels={channels}
            options={{
              chart: {
                type: 'area',
              },
              plotOptions: {
                area: {
                  stacking: 'percent',
                },
              },
              yAxis: {
                title: {
                  enabled: false,
                },
                labels: {
                  format: '{value}%',
                },
              },
            }}
          />
        </CardContent>
      </Card>
    </Fragment>
  )
}

export default Charts
